import {
  Drawer,
  Button,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react'
import { useMapCoreManager } from '../../contexts/MapCoreManager/Provider'
import AFACodeDrawer from './components/AFACodeDrawer'
import UnifiedPersonDrawer from './components/UnifiedPersonDrawer'
import AddressDrawer from './components/AddressDrawer'

export default function EntitiesDrawer() {
  const { selectedEntity, setSelectedEntity } = useMapCoreManager()

  const isOpen = !!selectedEntity

  return (
    <Drawer variant="map" isOpen={isOpen} onClose={() => setSelectedEntity(null)} placement="left">
      <DrawerOverlay
        backdropFilter="blur(2px)"
        bg="rgba(0, 0, 0, 0.5)"
        _dark={{ bg: 'rgba(0, 0, 0, 0.5)' }}
        // bg="rgba(0, 0, 0, 0.2)"
        // _dark={{ bg: 'rgba(0, 0, 0, 0.5)' }}
        // pointerEvents="none"
      />
      <DrawerContent>
        <DrawerCloseButton size="lg" />

        {selectedEntity?.type === 'unified_person' && <UnifiedPersonDrawer />}
        {selectedEntity?.type === 'afacode' && <AFACodeDrawer />}
        {selectedEntity?.type === 'address' && <AddressDrawer />}

        {selectedEntity?.type === 'event' && (
          <>
            <DrawerHeader>EVENT</DrawerHeader>
            <DrawerBody>EVENT</DrawerBody>
            <DrawerFooter>
              <Button variant="outline" mr={3} onClick={() => setSelectedEntity(null)}>
                Cancel
              </Button>
              <Button colorScheme="blue">Save</Button>
            </DrawerFooter>
          </>
        )}
      </DrawerContent>
    </Drawer>
  )
}
